import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import  reduxThunk from 'redux-thunk';
import { ApolloProvider } from '@apollo/client';
import apolloClient from './apolloClient';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import reducers from './reducers';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, {}, composeEnhancers(applyMiddleware(reduxThunk)));
const root = document.getElementById('root');
const data = root.getAttribute('data');

Sentry.init({
  dsn: "https://a7547cc80730408587ccf6fb84a868ed@o378482.ingest.sentry.io/5435233",
  environment: process.env.BANKDATA_ENV || 'dev',
  ignoreErrors: [
    "top.GLOBALS", // ignore random plugins/extensions errors
  ],
  integrations: [
    new Integrations.BrowserTracing(),
  ],
  // The above configuration captures both error and performance data. 
  // To reduce the volume of performance data captured, change tracesSampleRate to a value between 0 and 1.
  tracesSampleRate: 1.0,
});

ReactDOM.render(
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <BrowserRouter>
          <App data={data} />
        </BrowserRouter>
      </Provider>
    </ApolloProvider>,
    root
  );

 registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js